export const leaseExelCols = {
    leaseId: "ID",
    leaseName: "Lease ID",
    assetType: "Asset Type",
    rental: "Rental",
    currencyCode: "Currency",
    commencementDate: "Commencement Date",
    endDate: "End Date",
    annuity: "Annuity",
    ibr: "Interest Rate",
    frequency: "Payment Frequency",
    username: "User Name",
};
export const leaseReportExcelCol = {
    leaseId: "ID",
    leaseName: "Lease ID",
    rental: "Rental",
    frequency: "Payment Frequency",
    commencementDate: "Commencement Date",
    endDate: "End Date",
    openingLL: "Opening Lease Liability",
    interest: "Interest Expense",
    exchange_Gain_Loss: "Exchange Gain / (Loss)",
    modificationAdjustmentLL: "Modification Adjustment Lease Liability",
    payment: "Payments Due",
    closingLL: "Closing Lease Liability",
    openingROU: "Opening Right of Use Asset",
    amortization: "Amortization",
    closingROU: "Closing Right of Use Asset",
    modificationAdjustmentROU: "Modification Adjustment Right of Use Asset",
};
export const JEReportExcelCol = {
    id: "ID",
    leaseId: "Lease ID",
    jE_Date: "Date",
    particular: "Particular",
    debit: "Debit",
    credit: "Credit",
};
export const JEReportFilterExcelCol = {
    startDate: "Start Date",
    endDate: "End Date",
};
export const initialRecognitionExcelCols = {
    id: "ID",
    leaseId: "Lease ID",
    npv: "Net Present Value",
    paymentDate: "Payment Date",
    rental: "Rental",
    serialNo: "Serial No",
};
export const leaseLiabilityExcelCols = {
    opening: "Opening",
    closing: "Closing",
    exchange_Gain_Loss: "Exchange Gain / Loss",
    id: "ID",
    interest: "Interest",
    leaseId: "Lease ID",
    leaseLiability_Date: "Date",
    modificationAdjustmentLL: "Modification Adjustment",
    payment: "Payment"
};
export const rouScheduleExcelCols = {
    id: "ID",
    leaseId: "Lease ID",
    roU_Date: "Date",
    opening: "Opening",
    amortization: "Amortization",
    closing: "Closing"
};
export const disclosureReportExcelCols = {
    label: "Disclosure Report",
    value: " "
};
export const leaseWorkSheetsExcelCol = {
    leaseData: "Lease Data",
    initialRecognition: "Initial Recognition",
    leaseLiability: "Lease Liability",
    rouSchedule: "Right of Use Asset",
    journalEntries: "Journal Entries",
}